import {Col, Row} from 'antd';
import {useFormikContext} from 'formik';
import {Input} from 'formik-antd';
import {useIntl} from 'react-intl';
import FormItem from '../../../../../../../../shared/components/form-item';
import {
  getLocaleValue,
  handleChangeLocales,
} from 'src/shared/functions/change-locales';

interface IEditManageSubColorLanguageProps {
  code?: string;
  index?: number;
}

const EditManageSubColorLanguage = (
  props: IEditManageSubColorLanguageProps,
) => {
  const {code, index} = props;

  const {messages} = useIntl();

  const {setFieldValue, values} = useFormikContext<any>();

  return (
    <>
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <FormItem
            name='name'
            label={messages[
              'productAttributes.productAttributesPredefinedValues.name'
            ].toString()}
            titleTooltip={messages[
              'tooltip.productAttributes.productAttributesPredefinedValues.name'
            ].toString()}
            isTooltip
            fieldCommponent={
              <Input
                name='name'
                value={getLocaleValue(values?.locales, code, 'name')}
                onChange={(value) =>
                  handleChangeLocales(
                    values?.locales,
                    setFieldValue,
                    `locales`,
                    code,
                    'name',
                    value.target.value,
                  )
                }
              />
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default EditManageSubColorLanguage;
